var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { OnInit } from '@angular/core';
import { ActivatedRoute, NavigationEnd, Router, } from '@angular/router';
import { Tracking } from './tracking.service';
var PageViewTrackingComponent = /** @class */ (function () {
    function PageViewTrackingComponent(activatedRoute, tracking, router) {
        this.activatedRoute = activatedRoute;
        this.tracking = tracking;
        this.router = router;
    }
    PageViewTrackingComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.router.events.subscribe(function (event) {
            // track page views
            if (event instanceof NavigationEnd) {
                _this.tracking.trackPageView(getRecursiveRouteData(_this.activatedRoute.snapshot).is404);
            }
        });
    };
    return PageViewTrackingComponent;
}());
export { PageViewTrackingComponent };
/**
 * get config from nested child routes
 * TODO: we should enable paramsInheritanceStrategy instead
 */
export function getRecursiveRouteData(snapshot) {
    var data = snapshot.data;
    snapshot.children.forEach(function (child) {
        data = __assign({}, data, getRecursiveRouteData(child));
    });
    return data;
}
